import React from "react";
import { motion } from "framer-motion";

const STEPS = [
  { n: "01", title: "CV & video submission", desc: "Submit your resume and a short introduction video alongside your application." },
  { n: "02", title: "Group discussion", desc: "Shortlisted candidates are invited to a group discussion round." },
  { n: "03", title: "Personal interviews", desc: "Move through interview rounds with the Positive Moves team." },
  { n: "04", title: "Outcome", desc: "Final decisions and next steps are communicated directly by our hiring team." },
];

export default function ProcessSteps() {
  return (
    <div className="pm-process">
      {STEPS.map((s, i) => (
        <motion.div
          className="pm-process__step"
          key={s.n}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.45, delay: i * 0.1 }}
        >
          <span className="pm-process__num">{s.n}</span>
          <h4>{s.title}</h4>
          <p>{s.desc}</p>
        </motion.div>
      ))}
    </div>
  );
}
